import commonLogoutMixin from '@core_mixins/common-logout-mixin';

export default {
    // name: 'common-error-handling-mixin',
    mixins: [
        commonLogoutMixin
    ],
    data: () => ({}),
    created () {},
    mounted () {},
    methods: {
        async common_error_handling (error, cb) {
            if (process.env.NODE_ENV === 'development') {
                console.log(`common_error_handling ~ `);
                
                console.log(` ~ error => `, error);
                if (error.response) {
                    console.log(` ~ error.response => `, error.response);
                }
            }
            
            if (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        const is_alert_duplicate_login = localStorage.getItem('is_alert_duplicate_login')
                        await this.common_401_error_handling(is_alert_duplicate_login)
                    }
                }
            }

            if (cb) {
                await cb(error)
            }
        },
        async common_401_error_handling(is_alert_duplicate_login = localStorage.getItem('is_alert_duplicate_login')) {
            if (!is_alert_duplicate_login) {
                alert(this.$t(`다중 로그인 등 권한 오류가 발생했습니다. 다시 로그인해 주십시오.`))
                localStorage.setItem('is_alert_duplicate_login', 1)
            }
            
            await this.commonLogout()
        }
    }
}